/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux-immutable';
import { connectRouter } from 'connected-react-router/immutable';
import * as pluginReducerMap from 'pluginServices/reducers';

import globalReducer from 'containers/App/reducer';
import pluginReducer from 'data/Plugin/reducer';
import currentUserReducer from 'data/CurrentUser/reducer';
import connectionReducer from 'containers/ConnectionManager/reducer';
import languageProviderReducer from 'containers/LanguageProvider/reducer';
import workspacePluginsReducer from 'Workspace/Plugins/store/reducer';
import workspaceCohortsReducer from 'Workspace/Cohorts/store/reducer';
import workspaceCoursewareReducer from 'Workspace/Courseware/store/reducer';
import workspaceAdminReducers from 'Workspace/Admin/store/reducer';
import workspaceProjectsReducer from 'Workspace/Projects/store/reducer';
import workspacePublicationsReducer from 'Workspace/Publications/store/reducer';
import authorReducer from 'domains/author/reducer';
import subscriptionReducer from 'domains/subscription/reducer';
import toastManagerReducer from 'containers/ToastManager/reducer';
import modalReducer from 'containers/ModalManager/reducer';
import manualGradeConfigurationReducer from 'containers/ConnectionManager/ManualGrading/reducer';
import evaluableReducer from 'containers/ConnectionManager/Evaluable/reducer';

import { alfrescoFolderStructureReducer } from 'components/AlfrescoPicker/reducer';

/**
 * Creates the main reducer with the dynamically injected ones
 */

export default function createRootReducer(history, injectedReducers) {
  return combineReducers({
    router: connectRouter(history),
    global: globalReducer,
    currentUser: currentUserReducer,
    plugins: pluginReducer,
    language: languageProviderReducer,
    connection: connectionReducer,
    workspacePlugins: workspacePluginsReducer,
    workspaceCohorts: workspaceCohortsReducer,
    workspaceCourseware: workspaceCoursewareReducer,
    workspaceProjects: workspaceProjectsReducer,
    workspacePublications: workspacePublicationsReducer,
    author: authorReducer,
    subscription: subscriptionReducer,
    toastManager: toastManagerReducer,
    manualGradeConfiguration: manualGradeConfigurationReducer,
    evaluable: evaluableReducer,
    alfrescoFolderStructure: alfrescoFolderStructureReducer,
    modals: modalReducer,
    ...pluginReducerMap,
    ...workspaceAdminReducers,
    ...injectedReducers,
  });
}
